'use client';

import { OfflineGatedTooltip } from '@/app-shell/offline-recording/offline-gated-tooltip';
import { SidebarMenuButton, SidebarMenuItem } from '@heidi/design-system/page-shell';
import { forwardRef, type ReactNode } from 'react';
import type { NavItemMenuItemDataAttributes } from './nav-item.types';

type NavItemOfflineGatedProps = {
  itemClassName?: string;
  menuItemDataAttributes?: NavItemMenuItemDataAttributes;
  variant?: 'default' | 'emphasis' | 'action';
  layout?: 'default' | 'iconOnly';
  isIconOnly: boolean;
  label: string;
  testId?: string;
  resolvedAriaLabel?: string;
  ariaExpanded?: boolean;
  navV3ClassName?: string;
  buttonContent: ReactNode;
};

export const NavItemOfflineGated = forwardRef<HTMLLIElement, NavItemOfflineGatedProps>(
  function NavItemOfflineGated(
    {
      itemClassName,
      menuItemDataAttributes,
      variant,
      layout,
      isIconOnly,
      label,
      testId,
      resolvedAriaLabel,
      ariaExpanded,
      navV3ClassName,
      buttonContent,
    },
    ref
  ) {
    return (
      <SidebarMenuItem ref={ref} className={itemClassName} {...menuItemDataAttributes}>
        <OfflineGatedTooltip isOfflineGated className="block cursor-not-allowed">
          <SidebarMenuButton
            variant={variant}
            layout={layout}
            // In label-icons mode `SidebarMenuButton` renders its own tooltip for
            // `iconOnly` buttons, which would nest inside the offline tooltip.
            tooltip={isIconOnly ? undefined : label}
            isActive={false}
            disabled
            data-testid={testId}
            aria-label={resolvedAriaLabel}
            aria-expanded={ariaExpanded}
            className={navV3ClassName}
          >
            {buttonContent}
          </SidebarMenuButton>
        </OfflineGatedTooltip>
      </SidebarMenuItem>
    );
  }
);
